import { UserDetailsComponent } from './user-details/user-details.component'
import { UpdateUserComponent } from './update-user/update-user.component'
import { CreateUserComponent } from './create-user/create-user.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { UsersComponent } from './users.component'

import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const usersRoutes: Routes = [
  {
    path: 'admin/users',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'USER_MANAGEMENT',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: UsersComponent },
      {
        path: 'create',
        component: CreateUserComponent,
        data: {
          permissions: {
            only: 'USER_MANAGEMENT',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateUserComponent,
        data: {
          permissions: {
            only: 'USER_MANAGEMENT',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id',
        component: UserDetailsComponent,
        data: {
          permissions: {
            only: 'USER_MANAGEMENT',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
